import { api } from './client';

export interface TrendPoint {
  period: string;
  count: number;
}

export interface ReferrerStat {
  referrer: string;
  count: number;
}

export interface FieldCompletion {
  field: string;
  totalAppearances: number;
  filledCount: number;
  completionRate: number;
}

export const analyticsApi = {
  getTrends: (orgId: string, formId: string, period = 'day', from?: string, to?: string) => {
    const params = new URLSearchParams({ period });
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    return api.get<{ trends: TrendPoint[] }>(`/orgs/${orgId}/forms/${formId}/analytics/trends?${params}`);
  },

  getReferrers: (orgId: string, formId: string) =>
    api.get<{ referrers: ReferrerStat[] }>(`/orgs/${orgId}/forms/${formId}/analytics/referrers`),

  getCompletions: (orgId: string, formId: string) =>
    api.get<{ completions: FieldCompletion[] }>(`/orgs/${orgId}/forms/${formId}/analytics/completions`),

  getOverview: (orgId: string) =>
    api.get<{ overview: { totalForms: number; totalSubmissions: number; last30DaysSubmissions: number } }>(`/orgs/${orgId}/analytics/overview`),
};
